import type {
  FeedCommentItem,
  FeedReactionKind,
} from "../../shared/contracts/product-pages.js";

function sourcePath(sourceType: string, sourceId: string): string {
  return `/api/v1/feed/${encodeURIComponent(sourceType)}/${encodeURIComponent(sourceId)}`;
}

export async function setFeedReaction(
  sourceType: string,
  sourceId: string,
  kind: FeedReactionKind,
  on: boolean,
): Promise<void> {
  await request(
    `${sourcePath(sourceType, sourceId)}/reactions/${kind}`,
    on ? "PUT" : "DELETE",
  );
}

export async function listFeedComments(
  sourceType: string,
  sourceId: string,
): Promise<FeedCommentItem[]> {
  const payload = await request<{ comments: FeedCommentItem[] }>(
    `${sourcePath(sourceType, sourceId)}/comments`,
    "GET",
  );
  return payload.comments;
}

export async function addFeedComment(
  sourceType: string,
  sourceId: string,
  body: string,
): Promise<FeedCommentItem> {
  const payload = await request<{ comment: FeedCommentItem }>(
    `${sourcePath(sourceType, sourceId)}/comments`,
    "POST",
    { body },
  );
  return payload.comment;
}

export async function deleteFeedComment(commentId: string): Promise<void> {
  await request(
    `/api/v1/feed/comments/${encodeURIComponent(commentId)}`,
    "DELETE",
  );
}

async function request<T = unknown>(
  path: string,
  method: "GET" | "PUT" | "POST" | "DELETE",
  body?: Record<string, unknown>,
): Promise<T> {
  const response = await fetch(path, {
    method,
    credentials: "include",
    headers: {
      accept: "application/json",
      ...(body === undefined ? {} : { "content-type": "application/json" }),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  if (!response.ok) throw new Error(await problemMessage(response));
  return response.json() as Promise<T>;
}

async function problemMessage(response: Response): Promise<string> {
  const body = (await response.json().catch(() => null)) as {
    detail?: unknown;
  } | null;
  return typeof body?.detail === "string"
    ? body.detail
    : "The request could not be completed.";
}
